'use client';

import { Card, CardContent, CardHeader } from '@packages/shared/src/ui/Card/Card';
import { useIntl } from 'react-intl';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { ProductHintsCardFragmentFragmentDoc } from '@packages/gql/generated/shopping/ProductHintsCardFragmentFragmentDoc';
import { ProductHintsItem } from '../ProductHintsItem';
import { messages } from './messages';

/*
 * INFO: As of right now the data structure for productHints and legalHints is the same, so the components are mostly identical.
 * The data for these two might change in the future and then the two components would have to be split again. For this reason we decided to split into seperate cards them from the start.
 */

/* GraphQL */ `
  fragment ProductHintsCardFragment on Product {
    productHints {
      ...ProductHintsItemFragment
    }
  }
`;

export type ProductHintsCardProps = {
  /**
   * Product hints array from given product.
   */
  productHintsData: FragmentType<typeof ProductHintsCardFragmentFragmentDoc>;
};

/**
 * ProductHintsCard component displays all product hints
 * */
export const ProductHintsCard = ({ productHintsData }: ProductHintsCardProps) => {
  const { productHints } = getFragmentData(ProductHintsCardFragmentFragmentDoc, productHintsData);
  const { formatMessage } = useIntl();

  if (productHints.length === 0) return null;

  return (
    <Card>
      <CardHeader hasDivider>{formatMessage(messages.productHintsCardHeader)}</CardHeader>
      <CardContent className="py-2">
        <ul className="list-none space-y-2">
          {productHints.map((productHint, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={`ProductHintsItem${idx}`}>
              <ProductHintsItem data={productHint} />
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};
